<template>
  <v-dialog v-model="showModal" width="400" @click:outside=closeDialog>
      <v-card max-width="400">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text" >add salary</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="300">
            <v-form @submit.prevent ref="form">
              <v-text-field v-model="identifier" id="identifier" :rules="[required]" label="identifier" variant="underlined" class="form_field"></v-text-field>
              <v-text-field v-model="annual_amount" id="valuation" :rules="[required, numeric]" label="annual amount" variant="underlined" class="form_field" inputmode="decimal"></v-text-field>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" block>Submit</v-btn>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';

export default {
  props: {
    show: Boolean
  },
  data() {
    return {
      identifier: '',
      annual_amount: ''
    }
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get () {
        return this.show
      }
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),  
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {
        
        await axios.request({
          url: "/salaries/",
          method: "POST",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data: {
            identifier: this.identifier,
            annual_amount: this.annual_amount
          }
        });
          this.resetDataValues();
          this.$parent.getSalaries(); // update list on local
          this.$emit("close"); // close modal via parent
      } catch (error) {
        this.showSnackbar({ message: 'Failed to create salary' });
      }
    },
    closeDialog(){
      this.resetDataValues();
      this.$emit('close');
    },
    resetDataValues(){
      this.identifier = "";
      this.annual_amount = "";
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
    numeric (v) {
        return !isNaN(v) || 'must be a number'
    },
  }

}
</script>

<style scoped>

.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>